// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"OYCKi","rc-tabs-tab":"_7m8pB","rc-tabs-tab-active":"R8Q-W","tip":"KCy3+","tip-label":"_8-XQt","tip-group":"YQYe0"};